import * as React from 'react';
import { RichText, RichTextBlock } from 'prismic-reactjs';

import { Divider, Typography } from '@nelnet/unifi-components-react';

import TwoColumn from '../TwoColumn';
import UsageNotification from '../UsageNotification';

interface IVariationsProps {
  description?: RichTextBlock[];
  variations_examples?: RichTextBlock[];
  variations_items?: RichTextBlock[];
}

const Variations: React.FunctionComponent<IVariationsProps> = ({
  description,
  variations_examples,
  variations_items,
}) => {
  return (
    <>
      {variations_examples ? (
        <>
          <Divider style={{ height: '2px', marginTop: '2rem' }} />
          <Typography variant="h3" className="regular" align="left" margin={{ top: 2 }}>
            Examples and Variations
          </Typography>
        </>
      ) : null}
      {description ? (
        <Typography variant="body1" align="left" margin={{ top: 2, bottom: 2 }}>
          {RichText.asText(description)}
        </Typography>
      ) : null}
      {variations_examples ? (
        <>
          <TwoColumn variations_examples={variations_examples}></TwoColumn>
          <UsageNotification usage_notification_items={variations_items}></UsageNotification>
        </>
      ) : null}
    </>
  );
};

export default Variations;
